import React from 'react';
import { ISessionConfig } from '~/types/server.types';
import { SessionConfigInfoText } from '~/components/common/SessionConfigItem/SessionConfigItem.styles';
import { observer } from 'mobx-react';
import { useRootStore } from '~/stores/useRootStore';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';

interface Props {
    sessionConfig: ISessionConfig;
}

const SessionConfigItemOwnerName = ({ sessionConfig }: Props) => {
    const {
        userStore: { currUser },
        sessionStore: { currUserId },
        companyStore: {
            currCompany: { team_members }
        }
    } = useRootStore();

    const { t } = useTranslation(NAMESPACES.GLOBALS);

    const { user_id: sessionConfigCreatorId } = sessionConfig;

    const ownerName =
        sessionConfigCreatorId === currUserId
            ? currUser.full_name
            : team_members.find(curr => curr._id === sessionConfigCreatorId)
                  ?.full_name;

    return (
        <SessionConfigInfoText>
            {t('owner', { ownerName })}
        </SessionConfigInfoText>
    );
};

export default observer(SessionConfigItemOwnerName);
